import React from 'react';
import { Tooltip } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface UserItem {
  id: number;
  name: string;
  status?: 'on' | 'off';
  is_active?: boolean;
}

interface NotificationType {
  id: number;
  name: string;
  is_enabled?: boolean;
  users?: UserItem[];
}

interface RightContactsPanelProps {
  type: NotificationType | null;
  typeEnabled: boolean;
  userEnabled: Record<number, boolean>;
  onToggleAll: (next: boolean) => void;
  onToggleUser: (userId: number) => void;
  searchQuery: string;
  onSearchChange: (val: string) => void;
}

const RightContactsPanel: React.FC<RightContactsPanelProps> = ({
  type,
  typeEnabled,
  userEnabled,
  onToggleAll,
  onToggleUser,
  searchQuery,
  onSearchChange,
}) => {
  const isDisabled = !typeEnabled || !type;
  const users = type?.users || [];
  const filteredUsers = users.filter(u =>
    !searchQuery || (u.name || '').toLowerCase().includes(searchQuery.toLowerCase())
  );
  const allOn = users.length > 0 && users.every(u => !!userEnabled[u.id]);

  return (
    <>
      <h3><b>Contacts</b><i>{type ? ` – ${type.name}` : ''}</i></h3>
      <input
        type="text"
        placeholder="Search User"
        className="search-box"
        value={searchQuery}
        onChange={(e) => onSearchChange(e.target.value)}
        disabled={isDisabled}
      />
      <table className={`contacts-table ${isDisabled ? 'disabled' : ''}`}>
        <thead>
          <tr>
            <th>Users name</th>
            <th style={{ display: 'flex', gap: '5px' }}>
              Status
              <Tooltip
                title='This reflects the user’s notification preference set in their profile.'
                arrow
                enterTouchDelay={0}
              >
                <span><FontAwesomeIcon icon="question-circle" size="sm" color="#0d2330" /></span>
              </Tooltip>
            </th>
            <th>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <span>Action</span>
                <label className={`switch ${isDisabled ? 'disabled' : ''}`} title="Toggle all">
                  <input
                    type="checkbox"
                    checked={Boolean(allOn)}
                    onChange={() => {
                      if (isDisabled) return;
                      onToggleAll(!allOn);
                    }}
                    disabled={isDisabled}
                  />
                  <span
                    className="slider round"
                    style={{
                      backgroundColor: isDisabled ? '#d2d6dc' : undefined,
                      opacity: isDisabled ? 0.85 : 1,
                      cursor: isDisabled ? 'not-allowed' : undefined,
                    }}
                  ></span>
                </label>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          {type && filteredUsers.length === 0 ? (
            <tr>
              <td colSpan={3} style={{ color: '#6b7280' }}>No user found</td>
            </tr>
          ) : type ? (
            filteredUsers.map(user => {
              const checked = !!userEnabled[user.id]
              
              return (
                <tr key={`${type.id}-${user.id}`} className={isDisabled ? 'disabled' : ''}>
                  <td>{user.name}</td>
                  <td>{user.status === 'on' ? 'On' : 'Off'}</td>
                  <td>
                    <label className={`switch ${isDisabled ? 'disabled' : ''}`}>
                      <input
                        type="checkbox"
                        checked={checked}
                        onChange={() => {
                          if (isDisabled) return;
                          onToggleUser(user.id);
                        }}
                        disabled={isDisabled}
                      />
                      <span
                        className="slider round"
                        style={{
                          backgroundColor: isDisabled ? '#d2d6dc' : undefined,
                          opacity: isDisabled ? 0.85 : 1,
                          cursor: isDisabled ? 'not-allowed' : undefined,
                        }}
                      ></span>
                    </label>
                  </td>
                </tr>
              );
            })
          ) : (
            <></>
          )}
        </tbody>
      </table>
    </>
  );
};

export default RightContactsPanel;
